import { defineMessages } from "locales/defineMessages";

// Class list, class create/edit form, session editor and venue picker (admin classes-mgmt).
export default defineMessages({
  vi: {
    // Class list
    "classList.title": "Quản lý lớp học ({count})",
    "classList.addClass": "Thêm lớp học",
    "classList.filterAll": "Tất cả",
    "classList.loadFailed": "Không tải được danh sách lớp học",
    "classList.empty": "Chưa có lớp học nào",
    "classList.noMatch": "Không tìm thấy lớp học nào",
    "classList.noMatchHint": "Thử đổi bộ lọc trạng thái.",
    "classList.studentCount": "{count} học viên",
    "classList.noManager": "Chưa phân công quản lý lớp",
    "classList.manageStudents": "Quản lý học viên",

    // Class form + create modal
    "classForm.createTitle": "Tạo lớp học mới",
    "classForm.editTitle": "Chỉnh sửa lớp học",
    "classForm.createModeBadge": "Chế độ tạo mới",
    "classForm.editModeBadge": "Chế độ cập nhật",
    "classForm.pageSubtitle":
      "Sắp xếp thông tin lớp, người phụ trách, lịch học và danh sách học viên trong một màn hình gọn hơn.",
    "classForm.noCreatePermission": "Bạn không có quyền tạo lớp học.",
    "classForm.basicInfoTitle": "Thông tin cơ bản",
    "classForm.basicInfoSubtitle":
      "Cấu hình tên lớp, trạng thái vận hành và người chịu trách nhiệm.",
    "classForm.nameLabel": "Tên lớp học",
    "classForm.namePlaceholder": "VD: Lớp yoga nâng cao",
    "classForm.nameRequired": "Vui lòng nhập tên lớp học",
    "classForm.statusLabel": "Trạng thái",
    "classForm.descriptionLabel": "Mô tả",
    "classForm.descriptionPlaceholder": "Nhập mô tả lớp học (không bắt buộc)",
    "classForm.descriptionPlaceholderLong":
      "Nhập mô tả lớp học, ghi chú chương trình hoặc hướng dẫn vận hành",
    "classForm.autoCreateSessions": "Tự động tạo buổi",
    "classForm.autoCreateSessionsHint": "Hàng tuần theo lịch lớp",
    "classForm.managersTitle": "Quản lý lớp phụ trách",
    "classForm.managersSubtitle": "Tìm và chọn nhiều người phụ trách.",
    "classForm.searchNameOrEmail": "Tìm theo tên hoặc email...",
    "classForm.noMatchingResults": "Không có kết quả phù hợp",
    "classForm.selectedCount": "Đã chọn {count}",
    "classForm.noManagerSelected": "Chưa chọn quản lý lớp",
    "classForm.unknownUser": "Người dùng",
    "classForm.noEmail": "Chưa có email",
    "classForm.loadFailed": "Không tải được thông tin lớp học",
    "classForm.loadManagersFailed": "Không tải được danh sách quản lý lớp",
    "classForm.createFailed": "Không thể tạo lớp học",
    "classForm.genericError": "Có lỗi xảy ra, vui lòng thử lại.",
    "classForm.creating": "Đang tạo...",
    "classForm.createSubmit": "Tạo lớp học",

    // Class form — students
    "classForm.searchStudentByName": "Tìm theo tên học viên...",
    "classForm.addStudent": "Thêm học viên",
    "classForm.noStudents": "Chưa có học viên nào",
    "classForm.noMatchingStudents": "Không tìm thấy học viên phù hợp",
    "classForm.transferAction": "Chuyển lớp",
    "classForm.removeFromClass": "Xóa khỏi lớp",
    "classForm.removeStudentConfirm": "Xóa học viên khỏi lớp?",
    "classForm.removeStudentFailed": "Xóa học viên thất bại",
    "classForm.addStudentModalTitle": "Thêm học viên vào lớp",
    "classForm.addStudentModalSubtitle":
      "Tìm kiếm và thêm nhanh học viên từ danh sách hiện có.",
    "classForm.searchStudentLabel": "Tìm học viên theo tên",
    "classForm.alreadyInClass": "Đã trong lớp",
    "classForm.remainingSessionsLabel": "Số buổi còn lại",
    "classForm.remainingSessionsPlaceholder": "Nhập số buổi...",
    "classForm.quickAddToSessions":
      "Thêm nhanh vào buổi học ({selected}/{total})",
    "classForm.noScheduledSessionsToPick":
      "Chưa có buổi học đã lên lịch để chọn nhanh.",
    "classForm.adding": "Đang thêm...",
    "classForm.remainingNonNegative": "Số buổi còn lại phải là số không âm",
    "classForm.selectedExceedsRemaining":
      "Số buổi học đã chọn không được vượt quá số buổi còn lại",
    "classForm.addStudentFailed": "Thêm học viên thất bại",
    "classForm.unscheduledSession": "Buổi học chưa lên lịch",

    // Class form — transfer
    "classForm.transferTitle": "Chuyển học viên sang lớp khác",
    "classForm.transferSubtitle":
      "Chuyển số buổi còn lại sang lớp mới và điều chỉnh các buổi đã lên lịch của học viên.",
    "classForm.transferCurrentRemaining": "Đang có {count} buổi",
    "classForm.transferTargetLabel": "Lớp đích",
    "classForm.transferTargetPlaceholder": "Chọn lớp cần chuyển đến",
    "classForm.transferTargetRemaining": "Số buổi hiện có ở lớp mới: {count}",
    "classForm.transferTargetExisting": "Đã có sẵn ở lớp này: {count} buổi",
    "classForm.transferCountLabel": "Số buổi chuyển",
    "classForm.transferSummaryRemaining": "Còn lại ở lớp hiện tại: {count}",
    "classForm.transferSummaryKept": "Buổi giữ lại ở lớp hiện tại: {count}",
    "classForm.transferSummaryTarget": "Số buổi ở lớp mới: {count}",
    "classForm.transferSourceSessionsTitle": "Buổi đã lên lịch ở lớp hiện tại",
    "classForm.transferSourceSessionsHint":
      "Bỏ chọn buổi nào thì học viên sẽ bị xóa khỏi buổi đó.",
    "classForm.loadingSessions": "Đang tải buổi học...",
    "classForm.studentHasNoScheduledSessions":
      "Học viên chưa có buổi nào đã lên lịch.",
    "classForm.transferTargetSessionsTitle": "Thêm nhanh vào buổi của lớp mới",
    "classForm.transferTargetSessionsHint":
      "Chọn trước các buổi muốn thêm học viên sau khi chuyển lớp.",
    "classForm.selectTargetToLoadSessions":
      "Chọn lớp đích để tải danh sách buổi học.",
    "classForm.loadingTargetSessions": "Đang tải buổi học lớp mới...",
    "classForm.targetHasNoOpenSessions":
      "Lớp đích chưa có buổi học đang mở để thêm nhanh.",
    "classForm.studentAlreadyInSession": "Học viên đã có trong buổi này",
    "classForm.transferring": "Đang chuyển...",
    "classForm.transferSubmit": "Xác nhận chuyển lớp",
    "classForm.loadStudentSessionsFailed":
      "Không tải được danh sách buổi học của học viên",
    "classForm.transferTargetRequired": "Vui lòng chọn lớp đích",
    "classForm.transferCountPositive": "Số buổi chuyển phải lớn hơn 0",
    "classForm.transferCountExceedsRemaining":
      "Số buổi chuyển không được vượt quá số buổi còn lại",
    "classForm.transferKeptExceedsRemaining":
      "Số buổi còn lại ở lớp hiện tại không đủ cho các buổi đã giữ lại",
    "classForm.transferTargetExceedsCount":
      "Số buổi thêm vào lớp mới không được vượt quá số buổi chuyển",
    "classForm.transferFailed": "Chuyển lớp thất bại",
    "classForm.transferToast": "{name}: {details}.",
    "classForm.transferToastMoved": "đã chuyển {count} buổi",
    "classForm.transferToastRemoved": "bỏ {count} buổi cũ",
    "classForm.transferToastAdded": "thêm {count} buổi mới",

    // Class form — sessions
    "classForm.sessionsTitle": "Buổi học",
    "classForm.sessionsSubtitle":
      "Quản lý các buổi hiện có và thêm nhanh buổi mới ngay tại đây.",
    "classForm.sessionsCreatedCount": "Đã tạo: {count}",
    "classForm.venuesCount": "Địa điểm: {count}",
    "classForm.fromDate": "Từ ngày",
    "classForm.toDate": "Đến ngày",
    "classForm.createdSessionsHeader": "Buổi học đã tạo ({shown}/{total})",
    "classForm.noMatchingSessions": "Không có buổi học phù hợp",
    "classForm.sessionIndexTitle": "Buổi {index} — {title}",
    "classForm.noScheduledTime": "Chưa sắp lịch thời gian",
    "classForm.durationMinutes": "{count} phút",
    "classForm.noSessions": "Chưa có buổi học nào trong lớp này.",

    // Session editor
    "sessionEditor.createTitle": "Tạo buổi học mới",
    "sessionEditor.editTitle": "Chỉnh sửa buổi học",
    "sessionEditor.classLine": "Lớp: {name}",
    "sessionEditor.loading": "Đang tải dữ liệu buổi học...",
    "sessionEditor.loadFailed": "Không thể tải dữ liệu buổi học",
    "sessionEditor.classNotFound": "Không tìm thấy lớp học",
    "sessionEditor.dateLabel": "Ngày học",
    "sessionEditor.timeLabel": "Giờ học",
    "sessionEditor.outsideCheckinLabel": "Điểm danh ngoài phạm vi",
    "sessionEditor.toggleOn": "Đang bật",
    "sessionEditor.toggleOff": "Đang tắt",
    "sessionEditor.participantsTitle": "Người tham gia thực tế của buổi học",
    "sessionEditor.studentCount": "{count} học viên",
    "sessionEditor.checkingOverlap":
      "Đang kiểm tra trùng lịch người tham gia...",
    "sessionEditor.duplicateRolesWarning":
      "Có tài khoản đang được chọn đồng thời ở vai trò Quản lý lớp và Huấn luyện viên. Vui lòng chỉ giữ một vai trò cho mỗi tài khoản.",
    "sessionEditor.managerConflictWarning":
      "Có {count} quản lý lớp đang trùng lịch với buổi khác. Hệ thống chỉ cảnh báo và vẫn giữ nguyên lựa chọn quản lý lớp.",
    "sessionEditor.scheduleConflictWarning":
      "Có {count} tài khoản đang trùng lịch với buổi học khác ở khung giờ này. Hệ thống sẽ tự bỏ chọn các tài khoản trùng đã chọn trước đó.",
    "sessionEditor.addManager": "Thêm quản lý lớp",
    "sessionEditor.addTrainer": "Thêm huấn luyện viên",
    "sessionEditor.inChargeBadge": "Phụ trách buổi",
    "sessionEditor.noManagerSelected":
      "Chưa chọn quản lý lớp cho buổi học này.",
    "sessionEditor.noTrainerSelected":
      "Chưa chọn huấn luyện viên cho buổi học này.",
    "sessionEditor.overlapsWith": "Trùng với buổi: {sessions}",
    "sessionEditor.unknownSessionName": "(Không rõ tên buổi)",
    "sessionEditor.venueTitle": "Địa điểm học",
    "sessionEditor.venueHint":
      "Chọn địa điểm đã có sẵn hoặc tạo địa điểm mới kèm địa chỉ và tọa độ.",
    "sessionEditor.venueSelectLabel": "Chọn địa điểm áp dụng cho buổi học",
    "sessionEditor.dateTimeRequired":
      "Vui lòng chọn ngày và giờ bắt đầu/kết thúc",
    "sessionEditor.dateTimeInvalid": "Giá trị ngày hoặc giờ không hợp lệ",
    "sessionEditor.endBeforeStart":
      "Thời gian kết thúc phải sau thời gian bắt đầu",
    "sessionEditor.startInPast":
      "Không thể tạo buổi học với giờ bắt đầu trong quá khứ",
    "sessionEditor.duplicateRolesAlert":
      "Các tài khoản sau đang được chọn đồng thời ở vai trò Quản lý lớp và Huấn luyện viên:\n- {users}\n\nVui lòng bỏ chọn ở một vai trò trước khi lưu.",
    "sessionEditor.conflictOnSaveAlert":
      "Không thể lưu vì có tài khoản trùng lịch. Hệ thống đã tự bỏ chọn các tài khoản trùng:\n- {list}",
    "sessionEditor.autoRemovedAlert":
      "Hệ thống đã tự bỏ chọn do trùng lịch sau khi thay đổi ngày/giờ:\n\n{sections}",
    "sessionEditor.autoRemovedTrainers":
      "Huấn luyện viên bị bỏ chọn:\n- {list}",
    "sessionEditor.autoRemovedStudents": "Học viên bị bỏ chọn:\n- {list}",
    "sessionEditor.syncParticipantsFailed":
      "Đã lưu buổi học nhưng chưa đồng bộ được người tham gia. Bạn có thể cập nhật lại trong chi tiết buổi học.",
    "sessionEditor.saveFailed": "Lưu buổi học thất bại",
    "sessionEditor.deleteConfirm": "Xóa buổi học này?",
    "sessionEditor.deleteFailed": "Xóa buổi học thất bại",
    "sessionEditor.deleteSession": "Xóa buổi",
    "sessionEditor.saveChanges": "Lưu thay đổi",
    "sessionEditor.createSubmit": "Tạo buổi",
    "sessionEditor.dobLine": "Ngày sinh: {dob}",
    "sessionEditor.dobMissing": "Chưa cập nhật ngày sinh",
    "sessionEditor.remainingSessions": "Còn {count} buổi",
    "sessionEditor.searchStudentsLabel": "Tìm học viên tham gia",
    "sessionEditor.searchStudentsPlaceholder": "Nhập tên học viên...",
    "sessionEditor.noStudentsToPick":
      "Chưa có học viên trong lớp để chọn tham gia buổi này.",
    "sessionEditor.enrollmentRegistered": "Đã đăng ký",
    "sessionEditor.participantJoined": "Đang tham gia",
    "sessionEditor.participantConflict": "Trùng lịch",
    "sessionEditor.participantNotSelected": "Chưa chọn",
    "sessionEditor.pickManagersTitle": "Chọn quản lý lớp",
    "sessionEditor.pickTrainersTitle": "Chọn huấn luyện viên",
    "sessionEditor.searchByName": "Tìm theo tên...",
    "sessionEditor.alreadyInOtherRole":
      "Đã được chọn ở vai trò còn lại của buổi học này",
    "sessionEditor.done": "Xong",

    // Venue
    "venue.showCreateForm": "+ Tạo địa điểm mới",
    "venue.hideCreateForm": "Ẩn form tạo địa điểm",
    "venue.selectPlaceholder": "Chọn địa điểm có sẵn",
    "venue.noAddress": "Địa điểm này chưa có địa chỉ chi tiết",
    "venue.coordinates": "Vĩ độ {lat} • Kinh độ {lng}",
    "venue.noCoordinates": "Địa điểm đã chọn chưa có tọa độ.",
    "venue.nameLabel": "Tên địa điểm",
    "venue.namePlaceholder": "Ví dụ: Cơ sở A - Sân chính",
    "venue.addressLabel": "Địa chỉ",
    "venue.addressPlaceholder": "Ví dụ: 12 Nguyễn Huệ, Q1, TP.HCM",
    "venue.descriptionLabel": "Mô tả (tùy chọn)",
    "venue.descriptionPlaceholder":
      "Ví dụ: Bãi xe phía trước, vào cổng phụ số 2",
    "venue.latitude": "Vĩ độ",
    "venue.longitude": "Kinh độ",
    "venue.searchingAddress": "Đang tìm địa chỉ...",
    "venue.noSuggestions": "Không tìm thấy gợi ý phù hợp",
    "venue.missingServiceKey":
      "Chưa cấu hình REACT_APP_VIETMAP_SERVICE_KEY để gợi ý địa chỉ.",
    "venue.missingTileKey":
      "Thiếu cấu hình Vietmap tile key. Vui lòng thêm REACT_APP_VIETMAP_TILE_KEY vào file .env.",
    "venue.createAndSelect": "Tạo địa điểm và chọn",
    "venue.nameAndAddressRequired": "Vui lòng nhập tên và địa chỉ địa điểm",
    "venue.unknownCenter": "Không xác định được trung tâm của lớp",
    "venue.createFailed": "Không thể tạo địa điểm mới",
    "venue.searchFailed": "Không thể tìm kiếm địa chỉ",
    "venue.resolveFailed": "Không thể lấy tọa độ địa chỉ",
    "venue.serverUnreachable":
      "Không thể kết nối máy chủ. Vui lòng kiểm tra backend hoặc mạng.",
    "venue.sessionExpired": "Phiên đăng nhập đã hết hạn",
    "venue.requestFailed": "Không thể xử lý yêu cầu địa chỉ",
    "venue.missingRefId": "Thiếu ref_id của địa chỉ đã chọn",
    "venue.invalidResponse": "Phản hồi địa chỉ không hợp lệ",
    "venue.missingCoordinates": "Không lấy được tọa độ của địa chỉ đã chọn",
  },
  en: {
    // Class list
    "classList.title": "Class management ({count})",
    "classList.addClass": "Add class",
    "classList.filterAll": "All",
    "classList.loadFailed": "Failed to load classes",
    "classList.empty": "No classes yet",
    "classList.noMatch": "No classes found",
    "classList.noMatchHint": "Try a different status filter.",
    "classList.studentCount": "{count} students",
    "classList.noManager": "No class manager assigned",
    "classList.manageStudents": "Manage students",

    // Class form + create modal
    "classForm.createTitle": "Create class",
    "classForm.editTitle": "Edit class",
    "classForm.createModeBadge": "Create mode",
    "classForm.editModeBadge": "Edit mode",
    "classForm.pageSubtitle":
      "Manage class details, managers, schedule and students on a single screen.",
    "classForm.noCreatePermission":
      "You don't have permission to create classes.",
    "classForm.basicInfoTitle": "Basic information",
    "classForm.basicInfoSubtitle":
      "Set the class name, status and who is responsible.",
    "classForm.nameLabel": "Class name",
    "classForm.namePlaceholder": "e.g. Advanced yoga",
    "classForm.nameRequired": "Please enter a class name",
    "classForm.statusLabel": "Status",
    "classForm.descriptionLabel": "Description",
    "classForm.descriptionPlaceholder": "Class description (optional)",
    "classForm.descriptionPlaceholderLong":
      "Class description, curriculum notes or operating instructions",
    "classForm.autoCreateSessions": "Auto-create sessions",
    "classForm.autoCreateSessionsHint": "Weekly, following the class schedule",
    "classForm.managersTitle": "Class managers",
    "classForm.managersSubtitle": "Search and select one or more managers.",
    "classForm.searchNameOrEmail": "Search by name or email...",
    "classForm.noMatchingResults": "No matching results",
    "classForm.selectedCount": "{count} selected",
    "classForm.noManagerSelected": "No class manager selected",
    "classForm.unknownUser": "User",
    "classForm.noEmail": "No email",
    "classForm.loadFailed": "Failed to load class details",
    "classForm.loadManagersFailed": "Failed to load class managers",
    "classForm.createFailed": "Failed to create class",
    "classForm.genericError": "Something went wrong, please try again.",
    "classForm.creating": "Creating...",
    "classForm.createSubmit": "Create class",

    // Class form — students
    "classForm.searchStudentByName": "Search by student name...",
    "classForm.addStudent": "Add student",
    "classForm.noStudents": "No students yet",
    "classForm.noMatchingStudents": "No matching students",
    "classForm.transferAction": "Transfer class",
    "classForm.removeFromClass": "Remove from class",
    "classForm.removeStudentConfirm": "Remove this student from the class?",
    "classForm.removeStudentFailed": "Failed to remove student",
    "classForm.addStudentModalTitle": "Add students to class",
    "classForm.addStudentModalSubtitle":
      "Search and quickly add students from the existing list.",
    "classForm.searchStudentLabel": "Search students by name",
    "classForm.alreadyInClass": "Already in class",
    "classForm.remainingSessionsLabel": "Remaining sessions",
    "classForm.remainingSessionsPlaceholder": "Enter number of sessions...",
    "classForm.quickAddToSessions":
      "Quick add to sessions ({selected}/{total})",
    "classForm.noScheduledSessionsToPick":
      "No scheduled sessions to pick from yet.",
    "classForm.adding": "Adding...",
    "classForm.remainingNonNegative":
      "Remaining sessions must be a non-negative number",
    "classForm.selectedExceedsRemaining":
      "Selected sessions cannot exceed remaining sessions",
    "classForm.addStudentFailed": "Failed to add student",
    "classForm.unscheduledSession": "Unscheduled session",

    // Class form — transfer
    "classForm.transferTitle": "Transfer student to another class",
    "classForm.transferSubtitle":
      "Move remaining sessions to the new class and adjust the student's scheduled sessions.",
    "classForm.transferCurrentRemaining": "{count} sessions remaining",
    "classForm.transferTargetLabel": "Target class",
    "classForm.transferTargetPlaceholder": "Select a class to transfer to",
    "classForm.transferTargetRemaining":
      "Sessions already in the new class: {count}",
    "classForm.transferTargetExisting":
      "Already enrolled in this class: {count} sessions",
    "classForm.transferCountLabel": "Sessions to transfer",
    "classForm.transferSummaryRemaining": "Left in current class: {count}",
    "classForm.transferSummaryKept": "Sessions kept in current class: {count}",
    "classForm.transferSummaryTarget": "Sessions in new class: {count}",
    "classForm.transferSourceSessionsTitle":
      "Scheduled sessions in current class",
    "classForm.transferSourceSessionsHint":
      "Unchecked sessions will remove the student from them.",
    "classForm.loadingSessions": "Loading sessions...",
    "classForm.studentHasNoScheduledSessions":
      "This student has no scheduled sessions.",
    "classForm.transferTargetSessionsTitle": "Quick add to new class sessions",
    "classForm.transferTargetSessionsHint":
      "Pick sessions to add the student to after the transfer.",
    "classForm.selectTargetToLoadSessions":
      "Select a target class to load its sessions.",
    "classForm.loadingTargetSessions": "Loading new class sessions...",
    "classForm.targetHasNoOpenSessions":
      "The target class has no open sessions to add to.",
    "classForm.studentAlreadyInSession": "Student is already in this session",
    "classForm.transferring": "Transferring...",
    "classForm.transferSubmit": "Confirm transfer",
    "classForm.loadStudentSessionsFailed":
      "Failed to load the student's sessions",
    "classForm.transferTargetRequired": "Please select a target class",
    "classForm.transferCountPositive":
      "Sessions to transfer must be greater than 0",
    "classForm.transferCountExceedsRemaining":
      "Sessions to transfer cannot exceed remaining sessions",
    "classForm.transferKeptExceedsRemaining":
      "Not enough remaining sessions in the current class for the kept sessions",
    "classForm.transferTargetExceedsCount":
      "Sessions added to the new class cannot exceed sessions transferred",
    "classForm.transferFailed": "Failed to transfer class",
    "classForm.transferToast": "{name}: {details}.",
    "classForm.transferToastMoved": "transferred {count} sessions",
    "classForm.transferToastRemoved": "removed {count} old sessions",
    "classForm.transferToastAdded": "added {count} new sessions",

    // Class form — sessions
    "classForm.sessionsTitle": "Sessions",
    "classForm.sessionsSubtitle":
      "Manage existing sessions and quickly add new ones here.",
    "classForm.sessionsCreatedCount": "Created: {count}",
    "classForm.venuesCount": "Venues: {count}",
    "classForm.fromDate": "From",
    "classForm.toDate": "To",
    "classForm.createdSessionsHeader": "Created sessions ({shown}/{total})",
    "classForm.noMatchingSessions": "No matching sessions",
    "classForm.sessionIndexTitle": "Session {index} — {title}",
    "classForm.noScheduledTime": "No time scheduled",
    "classForm.durationMinutes": "{count} min",
    "classForm.noSessions": "This class has no sessions yet.",

    // Session editor
    "sessionEditor.createTitle": "Create session",
    "sessionEditor.editTitle": "Edit session",
    "sessionEditor.classLine": "Class: {name}",
    "sessionEditor.loading": "Loading session data...",
    "sessionEditor.loadFailed": "Failed to load session data",
    "sessionEditor.classNotFound": "Class not found",
    "sessionEditor.dateLabel": "Date",
    "sessionEditor.timeLabel": "Time",
    "sessionEditor.outsideCheckinLabel": "Out-of-range check-in",
    "sessionEditor.toggleOn": "On",
    "sessionEditor.toggleOff": "Off",
    "sessionEditor.participantsTitle": "Session participants",
    "sessionEditor.studentCount": "{count} students",
    "sessionEditor.checkingOverlap":
      "Checking participants for schedule conflicts...",
    "sessionEditor.duplicateRolesWarning":
      "Some accounts are selected as both Class manager and Trainer. Please keep only one role per account.",
    "sessionEditor.managerConflictWarning":
      "{count} class managers have a schedule conflict with another session. This is only a warning; the selection is kept.",
    "sessionEditor.scheduleConflictWarning":
      "{count} accounts have a schedule conflict with another session in this time slot. Previously selected conflicting accounts will be deselected automatically.",
    "sessionEditor.addManager": "Add class manager",
    "sessionEditor.addTrainer": "Add trainer",
    "sessionEditor.inChargeBadge": "In charge",
    "sessionEditor.noManagerSelected":
      "No class manager selected for this session.",
    "sessionEditor.noTrainerSelected": "No trainer selected for this session.",
    "sessionEditor.overlapsWith": "Conflicts with: {sessions}",
    "sessionEditor.unknownSessionName": "(Unnamed session)",
    "sessionEditor.venueTitle": "Venue",
    "sessionEditor.venueHint":
      "Choose an existing venue or create a new one with address and coordinates.",
    "sessionEditor.venueSelectLabel": "Venue for this session",
    "sessionEditor.dateTimeRequired": "Please select a date and start/end time",
    "sessionEditor.dateTimeInvalid": "Invalid date or time",
    "sessionEditor.endBeforeStart": "End time must be after start time",
    "sessionEditor.startInPast":
      "Cannot create a session that starts in the past",
    "sessionEditor.duplicateRolesAlert":
      "The following accounts are selected as both Class manager and Trainer:\n- {users}\n\nPlease deselect one role before saving.",
    "sessionEditor.conflictOnSaveAlert":
      "Cannot save because some accounts have schedule conflicts. They have been deselected automatically:\n- {list}",
    "sessionEditor.autoRemovedAlert":
      "Some participants were deselected due to schedule conflicts after the date/time changed:\n\n{sections}",
    "sessionEditor.autoRemovedTrainers": "Deselected trainers:\n- {list}",
    "sessionEditor.autoRemovedStudents": "Deselected students:\n- {list}",
    "sessionEditor.syncParticipantsFailed":
      "The session was saved but participants could not be synced. You can update them in the session details.",
    "sessionEditor.saveFailed": "Failed to save session",
    "sessionEditor.deleteConfirm": "Delete this session?",
    "sessionEditor.deleteFailed": "Failed to delete session",
    "sessionEditor.deleteSession": "Delete session",
    "sessionEditor.saveChanges": "Save changes",
    "sessionEditor.createSubmit": "Create session",
    "sessionEditor.dobLine": "Date of birth: {dob}",
    "sessionEditor.dobMissing": "Date of birth not set",
    "sessionEditor.remainingSessions": "{count} sessions left",
    "sessionEditor.searchStudentsLabel": "Search participating students",
    "sessionEditor.searchStudentsPlaceholder": "Enter student name...",
    "sessionEditor.noStudentsToPick":
      "No students in this class to add to this session.",
    "sessionEditor.enrollmentRegistered": "Registered",
    "sessionEditor.participantJoined": "Participating",
    "sessionEditor.participantConflict": "Conflict",
    "sessionEditor.participantNotSelected": "Not selected",
    "sessionEditor.pickManagersTitle": "Select class managers",
    "sessionEditor.pickTrainersTitle": "Select trainers",
    "sessionEditor.searchByName": "Search by name...",
    "sessionEditor.alreadyInOtherRole":
      "Already selected in the other role for this session",
    "sessionEditor.done": "Done",

    // Venue
    "venue.showCreateForm": "+ New venue",
    "venue.hideCreateForm": "Hide venue form",
    "venue.selectPlaceholder": "Select an existing venue",
    "venue.noAddress": "This venue has no detailed address",
    "venue.coordinates": "Lat {lat} • Lng {lng}",
    "venue.noCoordinates": "The selected venue has no coordinates.",
    "venue.nameLabel": "Venue name",
    "venue.namePlaceholder": "e.g. Campus A - Main court",
    "venue.addressLabel": "Address",
    "venue.addressPlaceholder": "e.g. 12 Nguyen Hue, District 1, HCMC",
    "venue.descriptionLabel": "Description (optional)",
    "venue.descriptionPlaceholder": "e.g. Parking in front, use side gate 2",
    "venue.latitude": "Latitude",
    "venue.longitude": "Longitude",
    "venue.searchingAddress": "Searching addresses...",
    "venue.noSuggestions": "No matching suggestions",
    "venue.missingServiceKey":
      "REACT_APP_VIETMAP_SERVICE_KEY is not configured for address suggestions.",
    "venue.missingTileKey":
      "Vietmap tile key is missing. Please add REACT_APP_VIETMAP_TILE_KEY to your .env file.",
    "venue.createAndSelect": "Create and select venue",
    "venue.nameAndAddressRequired": "Please enter the venue name and address",
    "venue.unknownCenter": "Could not determine the class's center",
    "venue.createFailed": "Failed to create venue",
    "venue.searchFailed": "Failed to search addresses",
    "venue.resolveFailed": "Failed to get address coordinates",
    "venue.serverUnreachable":
      "Cannot reach the server. Please check the backend or your network.",
    "venue.sessionExpired": "Your session has expired",
    "venue.requestFailed": "Could not process the address request",
    "venue.missingRefId": "The selected address is missing its ref_id",
    "venue.invalidResponse": "Invalid address response",
    "venue.missingCoordinates":
      "Could not get coordinates for the selected address",
  },
});
